<template>
  <div>
    <ul class="upload-file-list">
      <li
        class="upload-file-item"
        v-for="file in files"
        :key="'file' + file.uuid"
      >
        <label
          :for="'upload' + pkey"
          class="custom-file-upload"
          v-if="file.status === 'none'"
        >
          <div><a-icon type="plus" /></div>
          <div>Seç</div>
        </label>

        <div class="upload-file-done" v-else-if="file.status === 'done'">
          <img
            v-if="file.type === 'IMAGE'"
            :src="imgthumburl + file.response.path"
          />

          <img
            v-if="file.type === 'AUDIO' || file.type == 'VIDEO'"
            style="width: 64px; margin-left: 5px; height: 64px"
            src="../../../assets/imgs/youtube.png"
          />

          <img
            v-if="file.type === 'DOCUMENT'"
            style="background: white"
            src="../../../assets/imgs/file_formats3_docx-512.png"
          />

          <img
            v-if="file.type === 'EXCEL'"
            style="background: white"
            src="../../../assets/imgs/excel.png"
          />

          <img
            v-if="file.type === 'PDF'"
            style="background: white"
            src="../../../assets/imgs/adobe-acrobat-pdf-file-512.png"
          />
        </div>

        <div
          class="upload-file-loading"
          v-else-if="file.status === 'uploading'"
        >
          <a-spin :spinning="file.status === 'uploading'" />
          <div class="loadingtxt">Yüklənir</div>
        </div>

        <div class="layer" v-if="file.status === 'done'">
          <a-tooltip title="Bax">
            <a-button @click="showPreview(file)" icon="eye" />
          </a-tooltip>

          <a-tooltip title="Sil">
            <a-button @click="deleteFile(file)" icon="delete" />
          </a-tooltip>
        </div>

        <input
          :id="'upload' + pkey"
          ref="file"
          type="file"
          :disabled="disabled"
          @change="handleUploadChange"
          :accept="respFileTypes"
        />
      </li>
    </ul>

    <div style="font-size: 12px; margin-top: 10px">
      <div><span style="color: red">*</span>Dəstəklənən fayl tipləri:</div>

      <div>
        <span v-for="type in respFileTypesList" :key="type">
          {{ ` ${type} ` }}
        </span>
      </div>
    </div>

    <div style="font-size: 12px; margin-top: 10px">
      <div><span style="color: red">*</span>Maksimum fayl həcmi: 5MB</div>
    </div>

    <!--media dialog-->
    <a-modal
      v-model="mediadialogVisibility"
      :footer="null"
      centered
      :width="1000"
      :bodyStyle="{ width: '1000px', height: '650px' }"
    >
      <conditional-media :filesList="sfilesList"></conditional-media>
    </a-modal>
  </div>
</template>

<script>
import { URL } from "@/utils/api";
import mixin from "@/mixins/index";
import axios from "axios";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";

export default {
  name: "MyFileUpload",
  mixins: [mixin],
  props: {
    filesList: Array,
    pkey: String,
    max: {
      type: Number,
      required: true,
    },
    disabled:Boolean
  },
  components: {
    "conditional-media": ConditionalMedia,
  },
  data() {
    return {
      files: [],
      filesqueue: [],
      headers: { "Content-Type": "multipart/form-data" },
      mediadialogVisibility: false,
      sfilesList: [],
      imgthumburl: URL[process.env.NODE_ENV].file_url,
    };
  },
  watch: {
    filesList: {
      immediate: true,
      handler: function (newVal) {
        // this.files = newVal;
      },
    },
  },

  methods: {
    handleUploadChange(e) {
      if (this.files.length > this.max) {
        this.$message.error(`Ən çoxu ${this.max} fayl əlavə edə bilərsiz`);
        return;
      }
      if (this.$refs.file[0].files.length > 0) {
        const isSupportedType =
          Array.from([...this.respFileTypesList]).some(
            (type) => type === this.$refs.file[0].files[0].size.type
          ) || true;
        const doesExceedMaxSize =
          this.$refs.file[0].files[0].size > 5 * 1024 * 1024;

        if (doesExceedMaxSize || !isSupportedType) {
          this.$message.error("Faylın həcmi ən çoxu 5 MB olmalıdır");
          return;
        }

        this.files[this.files.length - 1].fileOb = this.$refs.file[0].files[0];
        // console.log(e.target.id.replace("upload", ""));
        this.files[this.files.length - 1].pkey = e.target.id.replace(
          "upload",
          ""
        );
        // console.log(this.files);
        let addedFile = this.files[this.files.length - 1];
        this.filesqueue.push(addedFile);
        if (this.files.length < this.max)
          this.files.push({
            uuid: new Date().getUTCMilliseconds(),
            path: null,
            status: "none",
            fileOb: null,
            response: null,
            pkey: null,
          });
        this.uploadFile();
      }
    },
    uploadFile() {
      let formData = new FormData();
      formData.append("file", this.filesqueue[0].fileOb);
      this.$set(this.filesqueue[0], "status", "uploading");
      axios
        .post(
          URL[process.env.NODE_ENV].service_api + "files",
          formData,
          this.headers
        )
        .then((response) => {
          if (!response.data.error) {
            this.filesqueue[0].status = "done";
            this.filesqueue[0].response = response.data.data;
            this.filesqueue[0].type = response.data.data.type;
          } else {
            this.filesqueue[0].status = "error";
            this.$message.error(response.data.error.message);
          }
          this.filesqueue.splice(0, 1);
          this.$emit(
            "upload-change",
            this.files
              .filter((item) => item.status === "done")
              .map((item) => {
                return {
                  path: item.response.path,
                  type: item.response.type,
                  uploadDateStr: item.response.uploadDateStr,
                };
              })
          ); 
        })
        .catch((err) => {
          this.filesqueue[0].status = "error";
          this.filesqueue.splice(0, 1);
          if (err.response && err.response.status == 415) {
            this.$message.error("Yükləmək istədiyiniz fayl tipi dəstəklənmir");
            return;
          }
          this.$message.error("Xəta baş verdi");
        });
    },
    deleteFile(file) {
      
      this.files = this.files.filter((item) => item.uuid !== file.uuid);

      const specID = this.files.findIndex(item => (item.uuid === "for_delete_icon"|| item.status==='none'))===-1;
      if(specID){
        this.files.push({
           uuid: 'for_delete_icon',
            path: null,
            status: "none",
            fileOb: null,
            response: null,
            pkey: null,
        })
      }
              this.$emit(
            "upload-change",
            this.files
              .filter((item) => item.status === "done")
              .map((item) => {
                return {
                  path: item.response.path,
                  type: item.response.type,
                  uploadDateStr: item.response.uploadDateStr,
                };
              })
          ); 
     /*  this.filesqueue[0].status = "none"; */
    },
    showPreview(file) {
      this.sfilesList = [file.response];
      this.mediadialogVisibility = true;
    },
  },
  created() {
    this.files.push({
      uuid: new Date().getUTCMilliseconds(),
      path: null,
      status: "none",
      fileOb: null,
      response: null,
      pkey: this.pkey,
    });
  },
};
</script>

<style scoped src="./index.scss" lang="scss"></style>
